import { render } from "./MainLayout.vue?vue&type=template&id=05a9653d"
const script = {}

import "../styles/mainLayout.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__